export enum PoolAnalyticsEvents {
  testDetailsView = "testDetails_view",
  testDetailsTabClicked = "testDetails_tabClicked",
}
